<div class="layout-footer justify-content-between">
    <span class="font-medium ml-3">v1.1.0</span>
    <span class="font-medium mr-3">Powered by Sava Info Systems Pvt. Ltd.</span>
</div>
